import React, { useEffect, useState } from "react";
import { makeStyles } from "@mui/styles";
import Button from "@mui/material/Button";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import TheInput from './_field_components/_TheInput';

const useStyles = makeStyles({
  fieldElement: {
    margin: "10px 0 10px 0 !important",
  },
  dialogActions: {
    padding: "0 30px 30px 30px !important",
  },
  elementsContainer: {
    display: "flex",
    alignItems: "left",
  },
  header: {
    margin: "0 0 20px 0 !important",
  },
  submitButton: {
    marginLeft: "10px!important"
  },
  status_wrapper: {
    padding: "0 0 10px 0 !important",
    textAlign: "center",
    color: '#444'
  },
});

const EditData = ({record, onClose, onSuccess, API_URL, UPDATE_FIELDS}) => {
  const classes = useStyles();
  const [show_form, setShowForm] = useState(true);
  const [form_data, setFormData] = useState({...record});
  const [show_error, setShowError] = useState(false);
  const [show_errors, setShowErrors] = useState(false);
  const [errors, setErrors] = useState([]);
  const [is_ready, setIsReady] = useState(false);
  const [is_submitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    loadFreshData()
  }, [record]);

  const loadFreshData = () => {
    fetch(`${API_URL}/${record.id}`)
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          setShowError(true);
          throw new Error("Something went wrong");
        }
      })
      .then((json) => {
        setFormData(json);
        setIsReady(true);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleSubmit = () => {
    setIsSubmitting(true);
    fetch(`${API_URL}/${record.id}`, {
      method: "PUT",
      headers: {"Content-Type": "application/json"},
      body: JSON.stringify(form_data),
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          setShowError(true);
          throw new Error("Something went wrong");
        }
      })
      .then((json) => {
        if(json.errors) {
          setShowErrors(true);
          setErrors(json.errors);
          setIsSubmitting(false);
        } else {
          setShowError(false);
          setShowForm(false);
          onSuccess("Successfully updated a record");
          onClose();
          setIsSubmitting(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setIsSubmitting(false);
      });
  };

  const handleClose = (e, reason) => {
    if(reason === "backdropClick") {
      // do nothing
    } else {
      setShowForm(false);
      setShowError(false);
      setShowErrors(false);
      setErrors([]);
      onClose();
    }
  };

  const handleFieldChange = (event) => {
    if(event.target.id !== undefined) {
      form_data[event.target.id] = event.target.value;
    } else {
      form_data[event.target.name] = event.target.value;
    }
    setFormData(form_data);
  };

  return (
    <>
      <Dialog open={show_form} onClose={handleClose} disableEscapeKeyDown>
        <DialogTitle>Edit Record</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Please make sure you have all the information you need before adding a new record.
            {show_errors && (
              <Alert severity="error">
                {errors.map((error) => (
                  <div>{error}</div>
                ))}
              </Alert>
            )}
          </DialogContentText>
          <hr/>
          {is_submitting && <div className={classes.status_wrapper}>Submitting...</div>}
          {!is_ready && <div className={classes.status_wrapper}>Loading...</div>}
          {is_ready && UPDATE_FIELDS.map((field, index) => (
            <TheInput
              field={field}
              form_data={form_data}
              handleFieldChange={handleFieldChange}
              is_submitting={is_submitting}
              index={index}
            />
          ))}
        </DialogContent>
        <DialogActions className={classes.dialogActions}>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleSubmit} color="primary" variant="contained" disabled={is_submitting}>
            {is_submitting ? 'Submitting...' : 'Submit'}
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={show_error}
        onClose={() => setShowError(false)}
      >
        <Alert severity="error">Something is not right, please try again...</Alert>
      </Snackbar>
    </>
  );
}

export default EditData;
